// extracted by mini-css-extract-plugin
module.exports = {"labelText":"InvoiceSection_labelText__3mWwe"};